import { render, staticRenderFns } from "./ServiceInfoBlock.vue?vue&type=template&id=fd84e5e4&scoped=true&"
import script from "./ServiceInfoBlock.vue?vue&type=script&lang=ts&"
export * from "./ServiceInfoBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceInfoBlock.vue?vue&type=style&index=0&id=fd84e5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd84e5e4",
  null
  
)

export default component.exports